module.exports = __webpack_public_path__ + "static/media/homepage_popup_genie.72431d24.png";